import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useChatWithUserPathname} from '../../../../data/hooks/chat/useChatWithUserPathname';
import {useI18n} from '../../../../data/hooks/i18nHooks';
import resolvePath from '../../../../misc/resolvePath';
import styles from './SayHello.module.scss';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

function SayHello(props) {
    const {eventId, user, baseRoute} = props,
        i18n = useI18n(),
        dispatch = useDispatch(),
        {pathname} = useLocation(),
        profilePathname = [baseRoute, user.user_id ?? user.id ?? '-', user.participant_id ?? '-'].join('/'),
        chatPathname = useChatWithUserPathname(user.user_id ?? user.id);

    const handleClick = useCallback(() => {
        app.history.push(resolvePath(pathname, profilePathname, chatPathname));
    }, [eventId, user, baseRoute]);

    return (
        <div className={styles.SayHello} onClick={handleClick}>
            <span>{i18n['doubleFavo.hello']}</span>
            <svg version="1.1" width="75.284462" height="32.107548" viewBox="0 0 75.284462 32.107548">
                <g transform="translate(-2.3472367,-4.2089715)">
                    <path d="M 10.56,29.439999 C 8.1032639,26.470079 4.8949759,24.489183 4.9088959,20.159999 4.9361279,11.689215 17.056928,8.0426876 23.68,6.4750717 36.41408,3.4610878 51.213439,3.4537918 63.679999,7.9555516 c 4.9536,1.7887679 12.27456,4.8994554 13.59072,10.6044474 1.57152,6.811616 -6.3888,11.333632 -11.67072,13.439999 -6.82112,2.72032 -13.79968,3.10528 -20.8,3.9312 -3.75776,0.44352 -7.756159,0.13824 -11.519999,-0.12 -3.715456,-0.25472 -7.476416,-1.55296 -11.2,-1.57088 -4.88768,-0.02368 -9.784928,0.58176 -14.7200001,0.64096 -1.08752,0.01312 -2.6169744,-0.07714 -4.5881471,-0.42304 C 5.5376483,32.637799 9.0487359,30.540575 10.56,29.439999" />
                </g>
            </svg>
        </div>
    );
}

export default SayHello;
